import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';

import { Toast } from 'primereact/toast';
import { Companyid, DATATABLE_CONFIG, USER_SUBMENU_ID, TENANT_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';


class MealPeriodList extends Component {
    state = {
        selectedItems: []
    }


    actionTemplate = (rowData) => {

        return <div className="actionCenter">
            {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
                // <Link to={"/Tenant/" + rowData.typeId + "/edit"}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
                <Link to={"/mealperiodlist/edit/" + rowData.mealPeriodId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>

            }
            {(this.getAccess !== undefined && this.getAccess.viewAccess !== false) &&
                // <Link to={"/Tenant/" + rowData.typeId + "/view"}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
                <Link to={"/mealperiodlist/view/" + rowData.mealPeriodId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>

            }
        </div>;
    }

    delete = () => {

        if (this.state.selectedItems.length > 0) {
            const updatedValue = this.state.selectedItems.map(value => {
                return { DeleteID: value.userId };
            })
            this.props.dynamicDeleteProcess('user', updatedValue, 'GeUsers');
        }
        else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select checkbox' });
        }

    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if (rowData.isActive === true || rowData.isActive === null) {
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
            {status}
        </div>;
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        // this.props.getMasterTableList('GeUsers');
        this.props.getMasterTableList('res/GetresMealPeriodList', Companyid);

    }

    // componentDidUpdate() {
    //     console.log("Selected Items:", this.state.selectedItems)
    // }

    render() {

        if (this.getAccess !== undefined && this.getAccess.viewAccess === false) {
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{ 'textAlign': 'right' }}>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );

        // let tableData = [];


        // if (this.props.tableLists !== undefined) {
        //     tableData = this.props.tableLists;
        // }

        let tableData = [];

        if (Array.isArray(this.props.tableLists)) {
            tableData = this.props.tableLists;
        } else if (this.props.tableLists) {
            tableData = [this.props.tableLists];
        }


        return (
            <div className="p-grid padding">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Meal Period List </h1>

                        <div className="p-grid">

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                    {(this.getAccess !== undefined && this.getAccess.addAccess !== false) &&
                                        <Link to="/mealperiodlist/add/new"><Button style={{ float: 'right' }} label="Add Meal Period" className="ml1" icon="pi pi-plus" /></Link>
                                    }
                                </div>
                            </div>

                            <div className="p-col-12" style={{ marginTop: '2em' }}>

                                <DataTable value={tableData}
                                    selection={this.state.selectedItems} onSelectionChange={e => this.setState({ selectedItems: e.value })}
                                    globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="mealPeriodCode" header="Code" sortable={true} />
                                    <Column field="mealPeriodName" header="Name" sortable={true} />
                                    <Column field="startTime" header="Start Time" sortable={true} />
                                    <Column field="endTime" header="End Time" sortable={true} />
                                    <Column field="isActive" header="Status" body={this.statusRender} sortable={true} />
                                    <Column field="action" body={this.actionTemplate} header="Action" />
                                </DataTable>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dynamicDeleteProcess: (model, data, func) => dispatch(actions.dynamicDeleteProcess(model, data, func)),
        getMasterTableList: (table, company) => dispatch(actions.getMasterTableList(table, company)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MealPeriodList);